import one from "../../images/Svg/mask.jpg";
import thumOne from "../../images/Svg/ThubnailMask.png";
import thumTwo from "../../images/Svg/ThumMask2.png";
import skip from "../../images/Svg/Skip.svg";
import two from "../../images/Svg/mask2.jpg";
import image from "../../images/Svg/image1.jpg";
import image2 from "../../images/Svg/image2.jpg";
import image3 from "../../images/Svg/image3.svg";
import brain from "../../images/Svg/brain.svg";
import setu from "../../images/Svg/setu.png";
import setu1 from "../../images/Svg/setuSocial.png";
import setu2 from "../../images/Svg/setuCenter.png";
import web3 from "../../images/Svg/web3.jpg";
import web3_1 from "../../images/Svg/web3_1.svg";
import web3_2 from "../../images/Svg/web3_2.svg";
import web3_3 from "../../images/Svg/web3_3.jpg";
import webThumb from "../../images/Svg/web3Thumb.png";
import buisness from "../../images/Svg/blogs/Buisness.svg";
import ThumBuisness from "../../images/Svg/blogs/ThumBuisness.png";
import lyingMan from "../../images/Svg/blogs/lying_man.svg";

export const BlogData = [
  {
    id: 1,
    title: "How to Make More Money from your Content",
    text: "“The algorithm’s targeting is invasive and at best unhelpful at worst to small creators who are just starting out. Wish there was a better way to monetize your content and get real time returns? Well there is!",
    outsideTags: ["Creators ", "Monetization ", "Social Media ", "Web3"],
    photo: one,
    photoLink: "https://i.ibb.co/N6wQy9R/mask.jpg",
    thumPhoto: thumOne,
    credit: "Vector created by pch.vector",
    creditLink:
      "https://www.freepik.com/free-vector/investor-with-laptop-monitoring-growth-dividends-trader-sitting-stack-money-investing-capital-analyzing-profit-graphs-vector-illustration-finance-stock-trading-investment_10173124.htm#&position=6&from_view=author",
    description: `<div> <p className='text-[18px] text-[#161616] pb-8'> “Skip ad>>” That’s the one button we’re all eager to press every time we browse the internet. Most of us go as far as installing ad blockers on  our browsers for a multitude of reasons, ranging from saving time to not having to confront how deeply “the algorithm” has our buying habits pinned down.  </p>  <img className='mx-auto' src=${skip}  /><p className='my-8 blog-text'>Well here’s the scoop, this model of monetisation doesn’t have  longevity. Yes, this supremely annoying and invasive model of monetisation based around ads is in fact, broken. Shocker. </p>  <p className='my-6 blog-text'>  Broken how? Well, there’s of course the targeting of users with the most profitable ads. This only happens via the constant feast upon user data   that’s collected after tracking activities and profiling users. </p>   <p className='my-6 blog-text'>It also leads to a skewed return structure where only a small elite     minority of creators actually reap around 90% of the benefits.  </p><h1 className='text-[36px] italic text-[#407BFF] font-bold mb-8'> Not only is the ads system predatory, it is also exclusionist in who  gets a cut.   </h1>   <img className="w-full" src=${image} alt="" />
    <div className="text-right  mb-4">  <a className="text-[16px] text-[#585858]" href="https://www.freepik.com/free-vector/flat-design-concept-with-three-human-characters-with-different-level-income-illustration_15481376.htm#query=economic%20inequality&position=0&from_view=search"  target={"_blank"}  > Vector created by macrovector </a> </div>
    <p className="blog-text">
      Here’s the kicker- Ways to monetise your content don’t have to be
      inherently invasive. Well, what’s the alternative then? Web 3.0, of
      course.
    </p>
    <p className="blog-text">
      Decentralised social media comes with the promise of not only cutting
      out the “middle-men” (aka Web 2.0 platforms) but it also accounts for
      the goodwill of individuals (Social Tipping), opening up various
      mass-adopted monetisation avenues for creators.
    </p>
    <h1 className="text-[36px] italic text-[#407BFF] font-bold mb-8">
      The promise of decentralized social media lies in a more decentralized
      and creator-friendly reward structure.
    </h1>   <img className="mb-6" src=${image2} alt="" />

    <div className="text-right  mb-4">  <a className="text-[16px] text-[#585858]" href="https://www.freepik.com/free-vector/successful-business-man-holding-trophy_11879381.htm#query=recognition&position=0&from_view=search"  target={"_blank"}  > Vector created by jcomp</a> </div>

     <p className="blog-text"> Here we look at the key features of a decentralized social media
     protocol called the DeSo protocol:</p>
   <div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
    <h3 className="text-[20px] text-[#407BFF] font-bold mb-2">
      Creator Coins
    </h3>
    <p className="blog-text">
      Creator coins are social tokens that convert brand value into a
      tradable asset. This is a new monetisation stream is exclusively
      available on Web 3.0.
    </p>
  </div>
  <div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
    <h3 className="text-[20px] text-[#407BFF] font-bold mb-2">
      Social Tipping
    </h3>
    <p className="blog-text">
      On DeSo (a Web 3.0 blockchain), the core mechanic introduced is called
      "diamonds". It functions as a “like”, only it allows users to directly
      give variable amounts of money to content.
    </p>
  </div>
  <div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
    <h3 className="text-[20px] text-[#407BFF] font-bold mb-2">
      Social NFTs
    </h3>
    <p className="blog-text">
      Creators find a market via Non-Fungible Tokens or NFTs. NFTs are
      digital assets that can be bought and sold, typically representing a
      piece of digital content.
    </p>
  </div> <p className="blog-text">
  The days of corporate social media are numbered. Decentralization allows
  more people to make more money without becoming dependent on platforms,
  making decentralisation that much more robust and reliable.
</p>
<p className="blog-text">
  As we go headlong into the roaring twenties, defunct business models
  will give way to more inclusive ones.
</p>
<p className="blog-text">
  The promise of decentralization is that it makes social media better for
  everyone. That's what our future holds. So, more money? It's in the bag.
</p> </div>`,
    tags: [
      "Influencer ",
      "Creators ",
      "Decentralised",
      "Social Media Platform",
      "Web3 ",
      "Deso",
      "Monetization ",
      "NFTs",
      "Money ",
      "Income",
      "Cyrptocurrency ",
    ],
  },

  {
    id: 2,
    title: "Why social media should be decentralized",
    text: "We’ve all read something on Twitter that made us go… ”This should’ve been kept in the drafts” so really, why does Elon Musk want to “free” Twitter, and is there really a need for Decentralised Social Media?",
    photo: two,
    thumPhoto: thumTwo,
    photoLink: "https://i.ibb.co/wS9V0Xd/mask2.jpg",
    outsideTags: ["Elon Musk ", "Decentralised   ", "Social Media ", "Web3"],
    credit: "Vector created by freepik",
    creditLink: `https://www.freepik.com/vectors/nft`,
    description: `<div> <p className='text-[18px] text-[#161616] pb-8'>As an influential billionaire and business magnate, Elon Musk concedes that privately-held social media platforms like Twitter control public discourse and eventually, public opinion.
    </p>  <img className='mx-auto mb-2' src=${image3}  />
    <div className="text-right  mb-4">  <a className="text-[16px] text-[#585858]" href="https://9gag.com/gag/aVx222O"  target={"_blank"}> Photo from 9gag </a> </div>
    
    <p className='my-8 blog-text'>Indeed, today, a handful of privately held conglomerates effectively control public discourse and also earn monopoly profits off of content that they don't even create. This model also allows these giants to regulate and censor your content to an unprecedented degree. </p>  
    <p className='my-6 blog-text'>
    Needless to say, this kind of control also allows them to fine-tune the content that goes “viral”, which gives leeway to promoting various private agendas and in some sense to effectively controlling the court of public opinion. </p> 
 <img className="w-full" src=${brain} alt="" />
    <div className="text-right  mb-4">  <a className="text-[16px] text-[#585858]" href="https://neurogrow.com/what-social-media-does-to-your-brain/"  target={"_blank"}  > Photo from neurogrow.com</a> </div>
    <p className="blog-text">
    The solution? In this case, it is glaringly obvious and fortunately, widely talked about in recent times; Decentralisation. 
    </p>
    <p className="blog-text">
    Decentralized social media platforms, in contrast to privately-held social media, store all data on a public blockchain, which means that anyone in the world can run a node that exposes their own curated feed. 
    </p>
    <p className="blog-text">
    In the case of DeSo, since DeSo is fully open-source, these users could even customize their UI and build custom algorithms to rank the influencers and posts in a way that serves their specific target customer.
    </p>
    <img className="mb-6" src=${setu} alt="" />

    <p className="blog-text"> Another strong argument against Web 2.0 platforms is that they collect and sell user data for big bucks, with decentralised Web 3.0 platforms, doing this isn’t viable as everything is available for a user to see. 

    </p>

    <p className="blog-text"> Decentralized social media is publicly accessible as an open utility. It can in theory solve a collective action problem among independent publishers by making it individually rational for them to contribute their content to a new globally-shared pool that they can never be di-intermediated from and that isn't controlled by a single company.
    </p>

    <p className="blog-text"> A post submitted to Instagram, TikTok, or Twitter belongs to these platforms, rather than the creator who posted it. The creators who actually produce this content are underpaid, under-engaged, and under-monetized thanks to an outdated ads-driven business model. 
    </p>

    <p className="blog-text"> Decentralized social media on the other hand allows creators to own their content and opens up monetization avenues such as social tokens, social NFTs, and social tipping. 
    </p>
   
    <img className="mb-6" src=${setu1} alt="" />

    <p className="blog-text"> The ads-driven business model forces companies to keep a walled garden around content, preventing external developers from innovating on top of it, and giving users and creators no choice but to continue using apps that solely they control.</p>

    <p className="blog-text"> With decentralized social media creators are empowered to own their own content and profit directly from it without suffering at the hands of “the algorithm”. Thus we can move from a world in which data is a heavily guarded, privately-owned resource to one in which it is more like a globally accessible utility that anyone can build on.
    </p>
    <img className="mb-6" src=${setu2} alt="" />

    <p className="blog-text"> Corporate-owned social media’s influence runs rather deep, this form of social media also sets up the incentive structure such that user and creator interests are compromised to maximize profit.</p>

    <p className="blog-text">In such a case, where both the consumers and creators, while being on the opposite ends of the spectrum, still stand to be exploited by centralised social media, a change isn’t just desired, it is necessary.
    </p>
   </div>`,
    tags: [
      "Elon Musk ",
      "Twitter ",
      "Decentralisation Social Media ",
      "Blockchain",
      "Web3 ",
      "DeSo ",
      "Monetisation ",
      "NFT creators ",
      "Web2 ",
      "open-source",
    ],
  },
  {
    id: 3,
    title: "What are Web 1.0, Web 2.0, and Web 3.0?",
    text: `There’s plenty of buzz around Web 3.0 and the sweeping changes it will bring to the industry, but few people actually know what Web 3.0 is really about. 
    So what is Web 3.0 really?`,
    photo: web3,
    photoLink: "https://i.ibb.co/CztyjxV/web3.jpg",
    thumPhoto: webThumb,
    outsideTags: ["Blockchain ", " Decentralised ", "Social Media ", " Web3"],
    credit: "Photo from gearrice.com",
    creditLink:
      "https://www.gearrice.com/update/what-is-web3-and-what-are-its-pillars-technology",
    description: `<div> <p className='text-[18px] text-[#161616] pb-8'>
    Web 3.0. That’s a term that elicits a variety of reactions, ranging from unbridled excitement (part and parcel of an hour-long conversation about crypto) to disgruntled eye-rolls to the heavens above. 
    </p>  
    
    <p className='text-[18px] text-[#161616] pb-8'>
    But what is Web 3.0 really? Now don’t go rolling your eyes, we promise not to bore you with an hour-long conversation about crypto.
    </p> 

    <p className='text-[18px] text-[#161616] pb-8'>
  Yes, there’s plenty of buzz around Web 3.0 and the sweeping changes it will bring   to the industry, but few people actually know what Web 3.0 is really about.
    </p> 
    
    <img className='mx-auto mb-2' src=${web3_1}  />
    <div className="text-right  mb-4">  <a className="text-[16px] text-[#585858]" href="https://medium.com/online-io-blockchain-technologies/web3-for-dummies-a-quick-guide-eaddc9fb3ab3"  target={"_blank"}> Photo from medium.com </a> </div>
    
    <p className='my-8 blog-text'>So, let’s get into it! To understand Web 3.0, it’s necessary to travel back in time and examine its anciiiiiient (we might be a little biased) predecessors, Web 1.0 & Web 2.0.  </p>  

    <div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
    <h3 className="text-[20px] text-[#407BFF] font-bold mb-2">
    Web 1.0
    </h3>
    <p className="blog-text">
    Presented static, necessity-based websites with little to no monetary incentives.
    ‘World Wide Web’ as it was known, was just a set of static websites with a load of information and no interactive content
    </p>
  </div>
  <div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
  <h3 className="text-[20px] text-[#407BFF] font-bold mb-2">
  Web 2.0
  </h3>
  <p className="blog-text">
  Provides, owns, and regulates dynamic user-generated content.
  We could call this the Read-Write-Publish era — where the spread of information is as simple as those three words.
  </p>
</div>
<div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
<h3 className="text-[20px] text-[#407BFF] font-bold mb-2">
Web 3.0
</h3>
<p className="blog-text">
We would call this, a read-write-own system.
Each user becomes a fractional owner of the platform. This is how we build trust in the system. 
</p>
</div>
    <p className='my-6 blog-text'>
    Web 3 will be a decentralized web that challenges the dominance of the tech giants by concentrating the power (and data) in the hands of the users, instead of corporations. A decentralised web essentially allows users to create their own value, invest and be invested in and have it all out on the blockchain for anybody to see, effectively cutting out the middleman.  </p> 
 <img className="w-full" src=${web3_2} alt="" />
    <div className="text-right  mb-4">  <a className="text-[16px] text-[#585858]" href="https://twitter.com/itsapollooo/status/1472896148738392071"  target={"_blank"}  > Photo from Twitter</a> </div>
    <p className="blog-text">
    The next generation of the World Wide Web is in its very initial stages, getting early users and building itself as it goes. Just as Web 2.0 started from an abstract concept of publishing information on an open network, Web 3.0 delves deeper into building a fairer and more transparent web. 
    </p>
    <p className="blog-text">
    As with everything, it’s hard to predict the progression of Web 3.0, in the context of mass adoption. The one clear way to speed up this inevitable shift is to become an early adapter and lead the wave of change, as with every revolutionary concept. 
    </p>
    <p className="blog-text">
    The rise of the human race is a story of ever-increasing cooperation. Even today, it's difficult to imagine an urgent human problem that can't be remedied primarily by increased cooperation.
    </p>
    <img className="mb-6" src=${web3_3} alt="" />

    <p className="blog-text">  So much of what we've built, so many of our greatest achievements as a species––like the Internet or space travel––have been genuinely global efforts. But how are such large-scale collaborations even possible? Everything is based on trust.
    </p>

    <p className="blog-text"> 
    The technology in this area is still in its infancy. This is the very first step. Countless pieces of the puzzle are still missing. Numerous issues are currently unresolved, but when these constraints are gradually removed, we will be able to use this new set of Lego building blocks to create things we cannot even dream of today.
    </p></div>`,
    tags: [
      "Web1",
      "Web2",
      "Web3",
      "User Dependence ",
      "Next Generation Web",
      "Cyrpto ",
      "Monetization",
      "Censor",
      "Open Network ",
      "Early Adapters ",
      "User Data",
    ],
  },
  {
    id: 4,
    title: "Why every Content Creator needs Setu",
    text: `The internet is constantly evolving and new opportunities for growth sprout up everywhere. In this fast-paced environment, learn how Setu helps creators stay ahead of the curve on Web3.`,
    photo: buisness,
    photoLink:
      "https://i.ibb.co/cxb4WPv/Business-team-climbing-giant-handshake-with-support-of-leader-1-1.png",
    thumPhoto: ThumBuisness,
    outsideTags: ["Content Creators ", " Web3 Tool ", "DeSo ", " PostToEarn"],
    credit: "Photo from freepik.com",
    creditLink:
      "https://www.freepik.com/free-vector/business-team-climbing-giant-handshake-with-support-leader_18733161.htm#query=ownership&position=24&from_view=search",
    description: `<div> <p className='text-[18px] text-[#161616] pb-8'>
    Being creators ourselves, we understand the problem creators face. Our vision is to enable every creator to increase their footprint in Web 3.0, so that they can earn more money, expand their value, and own their content.
    </p>  
    <p className='text-[18px] text-[#161616] pb-8'>
    Setu is built by content creators. We believe that content should be served without walls, and that dependence on private platforms is bad for creators. We want to empower creators to expand their brand, earn more money, and have ownership of their work.
    </p> 
    <p className='text-[18px] text-[#161616] pb-8'>
    This is precisely why we need to make social media posts portable from corporate social media. This is our first goal.
    </p> 
    <p className='text-[18px] text-[#161616] pb-8'>
    All of this content is legally “owned” by these platforms, even while it is the creators whose blood, sweat and tears have gone into making this content. 
    </p> 
    <h1 className='text-[36px] italic text-[#407BFF] font-bold mb-8'> The ownership must be that of the creators. 
    </h1>
    <img className="w-full mt-[24px] mb-[8px]" src=${lyingMan} alt="" />
    <div className="text-right  mb-4">  <a className="text-[16px] text-[#585858]" href="https://www.freepik.com/free-vector/lying-arrow-concept-illustration_22908886.htm#query=profit&position=9&from_view=keyword"  target={"_blank"}> Photo from freepik.com </a> </div>
    
    <p className='my-8 blog-text'>
    Corporate social media is designed in a way to not allow users to own their own content. Or at least they do a good job of making it confusing.
    </p>  

    <div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
    <p className="blog-text">
    For creators to own their content, it must be stored in a decentralized database. This is our <span className="text-blue">first goal</span>. Setu allows creators to make backups of their entire content library on blockchain for free. Doing this has dual benefits as it also enriches the decentralized social media ecosystem with proven viral content. 
    </p>
  </div>
  <div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
  <p className="blog-text">
  Our <span className="text-blue">next goal  </span>is to move the community. Currently, all of our social graphs live on corporate platforms. For decentralized social media to be successful, we must also incentivize the social graph to move. This is how we solve network debt. 
  </p>
  <p className="blog-text">
We want to make it easy for people to understand and use decentralised social media. To that effect, we have created several explainer blogs and Twitter threads.
</p> 
<p className="blog-text">
Setu’s success is inextricably linked to the success of the DeSo protocol. Therefore we are investing heavily into positive sum actions for the whole ecosystem. Setu has also invested heavily into incentivizing people to use the DeSo protocol. We have run several giveaways to reward people who post on the platform.
  </p>
</div>
<div className="bg-[#F6F7FF] border border-[#F6F7FF]  p-6 rounded-[32px] mb-4">
<p className="blog-text">
Our <span className="text-blue font-bold">third goal</span> is to be a one-stop solution for content creators. We’re currently developing a way for creators to be able to repurpose their content for various social media platforms automatically.
</p>
<p className="blog-text">
For instance, a 1-hour explainer video will automatically be turned into several easily consumable reels. This is how we plan to help creators escalate content production.
</p>
</div>
    <p className='my-6 blog-text'>
    So at the end of the day, not only is Setu helping creators shift to Web 3 but we’re also bringing the social graph benefitting the creators that much more and uplifting the whole DeSo environment, and soon we will also be the one-stop solution to your various platform based needs. </p> 
    <p className='my-6 blog-text'>
    So really, what are you waiting for?  <br />
    Web 3 is the future and this is the yellow brick road- try <a className="text-blue" href="https://web3setu.com/" target="_blank"> Setu </a> today!
    </p>
    </div>`,
    tags: [
      "Content Creators",
      "Web3 Tool",
      "Monetization",
      "PostToEarn",
      "DeSo",
    ],
  },
];
